export const aItems = [
  {
    "id": "A1",
    "name": "大邱大学",
    "info": "",
    "ranking": "亚洲900"
  },
  {
    "id": "A2",
    "name": "延世大学",
    "info": "",
    "ranking": 73
  },
  {
    "id": "A3",
    "name": "韩国外国语大学",
    "info": "",
    "ranking": 651
  },
  {
    "id": "A4",
    "name": "西江大学",
    "info": "",
    "ranking": 509
  },
  {
    "id": "A5",
    "name": "高丽大学",
    "info": "",
    "ranking": 67
  },
  {
    "id": "A6",
    "name": "汉阳大学",
    "info": "",
    "ranking": 162
  },
  {
    "id": "A7",
    "name": "世宗大学",
    "info": "",
    "ranking": 396
  },
  {
    "id": "A8",
    "name": "庆熙大学",
    "info": "",
    "ranking": 270
  },
  {
    "id": "A9",
    "name": "成均馆大学",
    "info": "",
    "ranking": 123
  },
  {
    "id": "A10",
    "name": "东国大学",
    "info": "",
    "ranking": 701
  },
  {
    "id": "A11",
    "name": "亚洲大学",
    "info": "",
    "ranking": 631
  },
  {
    "id": "A12",
    "name": "国民大学",
    "info": "",
    "ranking": "亚洲232"
  },
  {
    "id": "A13",
    "name": "仁荷大学",
    "info": "",
    "ranking": 632
  },
  {
    "id": "A14",
    "name": "全南大学",
    "info": "",
    "ranking": 851
  },
  {
    "id": "A15",
    "name": "岭南大学",
    "info": "",
    "ranking": 951
  },
  {
    "id": "A16",
    "name": "江原大学",
    "info": "",
    "ranking": 1001
  },
  {
    "id": "A17",
    "name": "韩国加图立大学",
    "info": "",
    "ranking": 801
  },
  {
    "id": "A18",
    "name": "明知大学",
    "info": "",
    "ranking": "亚洲351"
  },
  {
    "id": "A19",
    "name": "嘉泉大学",
    "info": "",
    "ranking": 601
  },
  {
    "id": "A20",
    "name": "江南大学",
    "info": ""
  },
  {
    "id": "A21",
    "name": "崇实大学",
    "info": "",
    "ranking": 1201
  },
  {
    "id": "A22",
    "name": "新罗大学",
    "info": "",
    "ranking": "亚洲801"
  },
  {
    "id": "A23",
    "name": "信韩大学",
    "info": ""
  },
  {
    "id": "A24",
    "name": "西京大学",
    "info": "",
    "ranking": "亚洲901"
  },
  {
    "id": "A25",
    "name": "清州大学",
    "info": ""
  },
  {
    "id": "A26",
    "name": "东西大学",
    "info": ""
  },
  {
    "id": "A27",
    "name": "大邱加图立大学",
    "info": ""
  },
  {
    "id": "A28",
    "name": "忠北大学",
    "info": "",
    "ranking": 1001
  },
  {
    "id": "A29",
    "name": "秋溪艺术大学",
    "info": ""
  },
  {
    "id": "A30",
    "name": "京畿大学",
    "info": ""
  },
  {
    "id": "A31",
    "name": "大真大学",
    "info": "",
    "ranking": "亚洲851"
  },
  {
    "id": "A32",
    "name": "东新大学",
    "info": ""
  },
  {
    "id": "A33",
    "name": "东亚大学",
    "info": ""
  },
  {
    "id": "A34",
    "name": "又石大学",
    "info": ""
  },
  {
    "id": "A35",
    "name": "南首尔大学",
    "info": ""
  },
  {
    "id": "A36",
    "name": "庆云大学",
    "info": ""
  }
];
export const bItems = [
  {
    "id": "B1",
    "name": "一般大学院",
    "info": "",
    "dormitory": "19453/年",
    "scholarship": "",
    "B_fee": "10000元",
    "B_fee_name": "语言课程",
    "connections": [
      {
        "a": "A1",
        "c": "C1",
        "d": "D5",
        "key": ""
      },
      {
        "a": "A1",
        "c": "C2",
        "d": "D2",
        "key": ""
      },
      {
        "a": "A1",
        "c": "C3",
        "d": "D1",
        "key": ""
      },
      {
        "a": "A1",
        "c": "C4",
        "d": "D1",
        "key": ""
      },
      {
        "a": "A1",
        "c": "C5",
        "d": "D4",
        "key": ""
      },
      {
        "a": "A1",
        "c": "C6",
        "d": "D4",
        "key": ""
      },
      {
        "a": "A1",
        "c": "C7",
        "d": "D3",
        "key": ""
      },
      {
        "a": "A1",
        "c": "C8",
        "d": "D9",
        "key": ""
      },
      {
        "a": "A1",
        "c": "C9",
        "d": "D99",
        "key": ""
      },
      {
        "a": "A1",
        "c": "C10",
        "d": "D6",
        "key": ""
      },
      {
        "a": "A1",
        "c": "C11",
        "d": "D10",
        "key": ""
      },
      {
        "a": "A1",
        "c": "C12",
        "d": "D11",
        "key": ""
      },
      {
        "a": "A1",
        "c": "C13",
        "d": "D99",
        "key": ""
      },
      {
        "a": "A1",
        "c": "C14",
        "d": "D16",
        "key": ""
      }
    ]
  },
  {
    "id": "B2",
    "name": "政经大学院",
    "info": "",
    "dormitory": "",
    "scholarship": "",
    "B_fee": "",
    "B_fee_name": "",
    "connections": [
      {
        "a": "A2",
        "c": "C15",
        "d": "D1",
        "key": ""
      },
      {
        "a": "A2",
        "c": "C16",
        "d": "D1",
        "key": ""
      }
    ]
  },
  {
    "id": "B3",
    "name": "一般大学院",
    "info": "",
    "dormitory": "",
    "scholarship": "",
    "B_fee": "",
    "B_fee_name": "",
    "connections": [
      {
        "a": "A2",
        "c": "C17",
        "d": "D15",
        "key": ""
      }
    ]
  },
  {
    "id": "B4",
    "name": "国际学研究生院",
    "info": "",
    "dormitory": "",
    "scholarship": "",
    "B_fee": "",
    "B_fee_name": "",
    "connections": [
      {
        "a": "A2",
        "c": "C18",
        "d": "D15",
        "key": ""
      }
    ]
  },
  {
    "id": "B5",
    "name": "商学",
    "info": "",
    "dormitory": "",
    "scholarship": "",
    "B_fee": "",
    "B_fee_name": "",
    "connections": [
      {
        "a": "A3",
        "c": "C19",
        "d": "D1",
        "key": ""
      },
      {
        "a": "A4",
        "c": "C20",
        "d": "D5",
        "key": ""
      }
    ]
  },
  {
    "id": "B6",
    "name": "一般大学院",
    "info": "第三批 6.2-6.13",
    "dormitory": "",
    "scholarship": "",
    "B_fee": "",
    "B_fee_name": "",
    "connections": [
      {
        "a": "A4",
        "c": "C21",
        "d": "D1",
        "key": ""
      }
    ]
  },
  {
    "id": "B7",
    "name": "创业经营研究生院",
    "info": "",
    "dormitory": "",
    "scholarship": "",
    "B_fee": "",
    "B_fee_name": "",
    "connections": [
      {
        "a": "A5",
        "c": "C22",
        "d": "D99",
        "key": ""
      }
    ]
  },
  {
    "id": "B8",
    "name": "一般大学院",
    "info": "",
    "dormitory": "",
    "scholarship": "",
    "B_fee": "",
    "B_fee_name": "",
    "connections": [
      {
        "a": "A6",
        "c": "C23",
        "d": "D1",
        "key": ""
      }
    ]
  },
  {
    "id": "B9",
    "name": "国际大学院",
    "info": "",
    "dormitory": "",
    "scholarship": "",
    "B_fee": "",
    "B_fee_name": "",
    "connections": [
      {
        "a": "A6",
        "c": "C24",
        "d": "D15",
        "key": ""
      }
    ]
  },
  {
    "id": "B10",
    "name": "经营专门大学院",
    "info": "",
    "dormitory": "",
    "scholarship": "",
    "B_fee": "",
    "B_fee_name": "",
    "connections": [
      {
        "a": "A6",
        "c": "C25",
        "d": "D1",
        "key": ""
      },
      {
        "a": "A6",
        "c": "C26",
        "d": "D1",
        "key": ""
      }
    ]
  },
  {
    "id": "B11",
    "name": "一般大学院",
    "info": "",
    "dormitory": "",
    "scholarship": "",
    "B_fee": "12000元",
    "B_fee_name": "项目管理费",
    "connections": [
      {
        "a": "A7",
        "c": "C27",
        "d": "D4",
        "key": ""
      },
      {
        "a": "A7",
        "c": "C28",
        "d": "D1",
        "key": ""
      },
      {
        "a": "A7",
        "c": "C29",
        "d": "D1",
        "key": ""
      },
      {
        "a": "A7",
        "c": "C30",
        "d": "D7",
        "key": ""
      },
      {
        "a": "A7",
        "c": "C31",
        "d": "D12",
        "key": ""
      }
    ]
  },
  {
    "id": "B12",
    "name": "经营大学院",
    "info": "第二批 6.9-6.20",
    "dormitory": "",
    "scholarship": "",
    "B_fee": "",
    "B_fee_name": "",
    "connections": [
      {
        "a": "A8",
        "c": "C33",
        "d": "D1",
        "key": ""
      }
    ]
  },
  {
    "id": "B13",
    "name": "技术经营大学院",
    "info": "第一批不合格不能申请第二批",
    "dormitory": "",
    "scholarship": "",
    "B_fee": "",
    "B_fee_name": "",
    "connections": [
      {
        "a": "A8",
        "c": "C34",
        "d": "D1",
        "key": ""
      }
    ]
  },
  {
    "id": "B14",
    "name": "中国大学院",
    "info": "",
    "dormitory": "",
    "scholarship": "",
    "B_fee": "",
    "B_fee_name": "",
    "connections": [
      {
        "a": "A9",
        "c": "C35",
        "d": "D1",
        "key": ""
      }
    ]
  },
  {
    "id": "B15",
    "name": "影像大学院",
    "info": "",
    "dormitory": "",
    "scholarship": "",
    "B_fee": "",
    "B_fee_name": "",
    "connections": [
      {
        "a": "A10",
        "c": "C36",
        "d": "D5",
        "key": ""
      },
      {
        "a": "A10",
        "c": "C37",
        "d": "D1",
        "key": ""
      }
    ]
  },
  {
    "id": "B16",
    "name": "文化艺术大学院",
    "info": "",
    "dormitory": "",
    "scholarship": "",
    "B_fee": "",
    "B_fee_name": "",
    "connections": [
      {
        "a": "A10",
        "c": "C38",
        "d": "D1",
        "key": ""
      }
    ]
  },
  {
    "id": "B17",
    "name": "经营大学院",
    "info": "",
    "dormitory": "",
    "scholarship": "",
    "B_fee": "",
    "B_fee_name": "",
    "connections": [
      {
        "a": "A10",
        "c": "C39",
        "d": "D1",
        "key": ""
      }
    ]
  },
  {
    "id": "B18",
    "name": "教育服务科技大学院",
    "info": "",
    "dormitory": "",
    "scholarship": "",
    "B_fee": "",
    "B_fee_name": "",
    "connections": [
      {
        "a": "A10",
        "c": "C40",
        "d": "D4",
        "key": ""
      },
      {
        "a": "A10",
        "c": "C41",
        "d": "D4",
        "key": ""
      }
    ]
  },
  {
    "id": "B19",
    "name": "一般大学院",
    "info": "",
    "dormitory": "7500/学期",
    "scholarship": "",
    "B_fee": "",
    "B_fee_name": "",
    "connections": [
      {
        "a": "A11",
        "c": "C42",
        "d": "D6",
        "key": ""
      }
    ]
  },
  {
    "id": "B20",
    "name": "国际创业风险投资研究生院",
    "info": "第二批 6.3-6.17",
    "dormitory": "",
    "scholarship": "",
    "B_fee": "",
    "B_fee_name": "",
    "connections": [
      {
        "a": "A12",
        "c": "C44",
        "d": "D1",
        "key": ""
      }
    ]
  },
  {
    "id": "B21",
    "name": "经营大学院",
    "info": "",
    "dormitory": "",
    "scholarship": "",
    "B_fee": "",
    "B_fee_name": "",
    "connections": [
      {
        "a": "A12",
        "c": "C43",
        "d": "D1",
        "key": ""
      }
    ]
  },
  {
    "id": "B22",
    "name": "创意国际大学院",
    "info": "",
    "dormitory": "",
    "scholarship": "",
    "B_fee": "",
    "B_fee_name": "",
    "connections": [
      {
        "a": "A13",
        "c": "C45",
        "d": "D11",
        "key": ""
      },
      {
        "a": "A13",
        "c": "C46",
        "d": "D16",
        "key": ""
      },
      {
        "a": "A13",
        "c": "C47",
        "d": "D2",
        "key": ""
      },
      {
        "a": "A13",
        "c": "C48",
        "d": "D4",
        "key": ""
      },
      {
        "a": "A13",
        "c": "C49",
        "d": "D7",
        "key": ""
      },
      {
        "a": "A13",
        "c": "C50",
        "d": "D1",
        "key": ""
      },
      {
        "a": "A13",
        "c": "C51",
        "d": "D5",
        "key": ""
      }
    ]
  },
  {
    "id": "B23",
    "name": "产学协力研究生院",
    "info": "",
    "dormitory": "3600/学期",
    "scholarship": "",
    "B_fee": "",
    "B_fee_name": "",
    "connections": [
      {
        "a": "A13",
        "c": "C52",
        "d": "D1",
        "key": ""
      }
    ]
  },
  {
    "id": "B24",
    "name": "朴正熙研究生院",
    "info": "",
    "dormitory": "",
    "scholarship": "",
    "B_fee": "",
    "B_fee_name": "",
    "connections": [
      {
        "a": "A14",
        "c": "C53",
        "d": "D15",
        "key": ""
      },
      {
        "a": "A15",
        "c": "C54",
        "d": "D99",
        "key": ""
      },
      {
        "a": "A15",
        "c": "C55",
        "d": "D99",
        "key": ""
      },
      {
        "a": "A15",
        "c": "C56",
        "d": "D7",
        "key": ""
      }
    ]
  },
  {
    "id": "B25",
    "name": "一般大学院",
    "info": "",
    "dormitory": "",
    "scholarship": "",
    "B_fee": "",
    "B_fee_name": "",
    "connections": [
      {
        "a": "A15",
        "c": "C57",
        "d": "D3",
        "key": ""
      },
      {
        "a": "A15",
        "c": "C58",
        "d": "D18",
        "key": ""
      },
      {
        "a": "A15",
        "c": "C59",
        "d": "D1",
        "key": ""
      }
    ]
  },
  {
    "id": "B26",
    "name": "一般大学院",
    "info": "",
    "dormitory": "",
    "scholarship": "",
    "B_fee": "",
    "B_fee_name": "",
    "connections": [
      {
        "a": "A16",
        "c": "C60",
        "d": "D1",
        "key": ""
      },
      {
        "a": "A16",
        "c": "C61",
        "d": "D12",
        "key": ""
      },
      {
        "a": "A16",
        "c": "C62",
        "d": "D1",
        "key": ""
      }
    ]
  },
  {
    "id": "B27",
    "name": "一般大学院",
    "info": "",
    "dormitory": "",
    "scholarship": "",
    "B_fee": "",
    "B_fee_name": "",
    "connections": [
      {
        "a": "A17",
        "c": "C63",
        "d": "D12",
        "key": ""
      },
      {
        "a": "A17",
        "c": "C64",
        "d": "D7",
        "key": ""
      },
      {
        "a": "A17",
        "c": "C65",
        "d": "D7",
        "key": ""
      },
      {
        "a": "A17",
        "c": "C66",
        "d": "D12",
        "key": ""
      },
      {
        "a": "A17",
        "c": "C67",
        "d": "D1",
        "key": ""
      },
      {
        "a": "A17",
        "c": "C68",
        "d": "D5",
        "key": ""
      },
      {
        "a": "A17",
        "c": "C69",
        "d": "D1",
        "key": ""
      },
      {
        "a": "A17",
        "c": "C70",
        "d": "D12",
        "key": ""
      },
      {
        "a": "A17",
        "c": "C71",
        "d": "D7",
        "key": ""
      },
      {
        "a": "A17",
        "c": "C72",
        "d": "D4",
        "key": ""
      },
      {
        "a": "A17",
        "c": "C73",
        "d": "D4",
        "key": ""
      },
      {
        "a": "A17",
        "c": "C74",
        "d": "D4",
        "key": ""
      },
      {
        "a": "A17",
        "c": "C75",
        "d": "D7",
        "key": ""
      }
    ]
  },
  {
    "id": "B28",
    "name": "一般大学院",
    "info": "",
    "dormitory": "6007/学期",
    "scholarship": "",
    "B_fee": "3684元",
    "B_fee_name": "韩国语特别课程（除经营学和行政学专业）",
    "connections": [
      {
        "a": "A18",
        "c": "C76",
        "d": "D1",
        "key": ""
      },
      {
        "a": "A18",
        "c": "C77",
        "d": "D99",
        "key": ""
      },
      {
        "a": "A18",
        "c": "C78",
        "d": "D4",
        "key": ""
      },
      {
        "a": "A18",
        "c": "C79",
        "d": "D12",
        "key": ""
      },
      {
        "a": "A18",
        "c": "C80",
        "d": "D7",
        "key": ""
      },
      {
        "a": "A18",
        "c": "C81",
        "d": "D13",
        "key": ""
      },
      {
        "a": "A18",
        "c": "C82",
        "d": "D12",
        "key": ""
      },
      {
        "a": "A18",
        "c": "C83",
        "d": "D11",
        "key": ""
      }
    ]
  },
  {
    "id": "B29",
    "name": "经营学MBA",
    "info": "二批：5.27~6.17",
    "dormitory": "14000/6个月",
    "scholarship": "",
    "B_fee": "",
    "B_fee_name": "",
    "connections": [
      {
        "a": "A19",
        "c": "C84",
        "d": "D1",
        "key": ""
      }
    ]
  },
  {
    "id": "B30",
    "name": "一般大学院",
    "info": "",
    "dormitory": "",
    "scholarship": "",
    "B_fee": "",
    "B_fee_name": "",
    "connections": [
      {
        "a": "A19",
        "c": "C85",
        "d": "D1",
        "key": ""
      },
      {
        "a": "A19",
        "c": "C86",
        "d": "D1",
        "key": ""
      },
      {
        "a": "A19",
        "c": "C87",
        "d": "D1",
        "key": ""
      },
      {
        "a": "A19",
        "c": "C88",
        "d": "D1",
        "key": ""
      },
      {
        "a": "A19",
        "c": "C89",
        "d": "D1",
        "key": ""
      },
      {
        "a": "A19",
        "c": "C90",
        "d": "D1",
        "key": ""
      }
    ]
  },
  {
    "id": "B31",
    "name": "国际研究生院",
    "info": "",
    "dormitory": "3684/学期",
    "scholarship": "",
    "B_fee": "",
    "B_fee_name": "",
    "connections": [
      {
        "a": "A20",
        "c": "C91",
        "d": "D1",
        "key": ""
      },
      {
        "a": "A20",
        "c": "C92",
        "d": "D1",
        "key": ""
      },
      {
        "a": "A20",
        "c": "C93",
        "d": "D12",
        "key": ""
      },
      {
        "a": "A20",
        "c": "C94",
        "d": "D12",
        "key": ""
      }
    ]
  },
  {
    "id": "B32",
    "name": "中小企业大学院",
    "info": "",
    "dormitory": "",
    "scholarship": "",
    "B_fee": "",
    "B_fee_name": "",
    "connections": [
      {
        "a": "A21",
        "c": "C95",
        "d": "D1",
        "key": ""
      }
    ]
  },
  {
    "id": "B33",
    "name": "一般大学院",
    "info": "",
    "dormitory": "",
    "scholarship": "",
    "B_fee": "5132元",
    "B_fee_name": "语言研修",
    "connections": [
      {
        "a": "A22",
        "c": "C96",
        "d": "D1",
        "key": ""
      },
      {
        "a": "A22",
        "c": "C97",
        "d": "D1",
        "key": ""
      },
      {
        "a": "A22",
        "c": "C98",
        "d": "D1",
        "key": ""
      },
      {
        "a": "A22",
        "c": "C99",
        "d": "D15",
        "key": ""
      },
      {
        "a": "A22",
        "c": "C100",
        "d": "D17",
        "key": ""
      },
      {
        "a": "A22",
        "c": "C101",
        "d": "D99",
        "key": ""
      },
      {
        "a": "A22",
        "c": "C102",
        "d": "D12",
        "key": ""
      },
      {
        "a": "A22",
        "c": "C103",
        "d": "D1",
        "key": ""
      }
    ]
  },
  {
    "id": "B34",
    "name": "一般大学院",
    "info": "6.10~6.18",
    "dormitory": "",
    "scholarship": "",
    "B_fee": "7300元",
    "B_fee_name": "韩语课程",
    "connections": [
      {
        "a": "A23",
        "c": "C104",
        "d": "D1",
        "key": ""
      },
      {
        "a": "A23",
        "c": "C105",
        "d": "D1",
        "key": ""
      },
      {
        "a": "A23",
        "c": "C106",
        "d": "D1",
        "key": ""
      },
      {
        "a": "A23",
        "c": "C107",
        "d": "D4",
        "key": ""
      },
      {
        "a": "A23",
        "c": "C108",
        "d": "D4",
        "key": ""
      },
      {
        "a": "A23",
        "c": "C109",
        "d": "D4",
        "key": ""
      },
      {
        "a": "A23",
        "c": "C110",
        "d": "D4",
        "key": ""
      },
      {
        "a": "A23",
        "c": "C111",
        "d": "D99",
        "key": ""
      },
      {
        "a": "A23",
        "c": "C112",
        "d": "D11",
        "key": ""
      },
      {
        "a": "A23",
        "c": "C113",
        "d": "D11",
        "key": ""
      }
    ]
  },
  {
    "id": "B35",
    "name": "国际融合大学院",
    "info": "",
    "dormitory": "",
    "scholarship": "",
    "B_fee": "",
    "B_fee_name": "",
    "connections": [
      {
        "a": "A24",
        "c": "C114",
        "d": "D4",
        "key": ""
      },
      {
        "a": "A24",
        "c": "C115",
        "d": "D4",
        "key": ""
      },
      {
        "a": "A24",
        "c": "C116",
        "d": "D4",
        "key": ""
      },
      {
        "a": "A24",
        "c": "C117",
        "d": "D1",
        "key": ""
      },
      {
        "a": "A24",
        "c": "C118",
        "d": "D1",
        "key": ""
      },
      {
        "a": "A24",
        "c": "C119",
        "d": "D12",
        "key": ""
      },
      {
        "a": "A24",
        "c": "C120",
        "d": "D21",
        "key": ""
      },
      {
        "a": "A24",
        "c": "C121",
        "d": "D21",
        "key": ""
      },
      {
        "a": "A24",
        "c": "C122",
        "d": "D21",
        "key": ""
      }
    ]
  },
  {
    "id": "B36",
    "name": "一般大学院",
    "info": "",
    "dormitory": "",
    "scholarship": "",
    "B_fee": "",
    "B_fee_name": "",
    "connections": [
      {
        "a": "A25",
        "c": "C123",
        "d": "D99",
        "key": ""
      },
      {
        "a": "A25",
        "c": "C124",
        "d": "D99",
        "key": ""
      },
      {
        "a": "A25",
        "c": "C125",
        "d": "D99",
        "key": ""
      },
      {
        "a": "A25",
        "c": "C126",
        "d": "D12",
        "key": ""
      }
    ]
  },
  {
    "id": "B37",
    "name": "一般大学院",
    "info": "",
    "dormitory": "3500/学期",
    "scholarship": "",
    "B_fee": "",
    "B_fee_name": "",
    "connections": [
      {
        "a": "A26",
        "c": "C127",
        "d": "D13",
        "key": ""
      },
      {
        "a": "A26",
        "c": "C128",
        "d": "D13",
        "key": ""
      }
    ]
  },
  {
    "id": "B38",
    "name": "一般大学院",
    "info": "",
    "dormitory": "",
    "scholarship": "",
    "B_fee": "",
    "B_fee_name": "",
    "connections": [
      {
        "a": "A27",
        "c": "C129",
        "d": "D99",
        "key": ""
      },
      {
        "a": "A27",
        "c": "C130",
        "d": "D6",
        "key": ""
      },
      {
        "a": "A27",
        "c": "C131",
        "d": "D2",
        "key": ""
      },
      {
        "a": "A27",
        "c": "C132",
        "d": "D6",
        "key": ""
      },
      {
        "a": "A27",
        "c": "C133",
        "d": "D5",
        "key": ""
      },
      {
        "a": "A27",
        "c": "C134",
        "d": "D99",
        "key": ""
      },
      {
        "a": "A27",
        "c": "C135",
        "d": "D11",
        "key": ""
      },
      {
        "a": "A27",
        "c": "C136",
        "d": "D99",
        "key": ""
      },
      {
        "a": "A27",
        "c": "C137",
        "d": "D10",
        "key": ""
      },
      {
        "a": "A27",
        "c": "C138",
        "d": "D99",
        "key": ""
      },
      {
        "a": "A27",
        "c": "C139",
        "d": "D12",
        "key": ""
      }
    ]
  },
  {
    "id": "B39",
    "name": "一般大学院",
    "info": "",
    "dormitory": "",
    "scholarship": "",
    "B_fee": "",
    "B_fee_name": "",
    "connections": [
      {
        "a": "A28",
        "c": "C140",
        "d": "D1",
        "key": ""
      },
      {
        "a": "A28",
        "c": "C141",
        "d": "D4",
        "key": ""
      },
      {
        "a": "A28",
        "c": "C142",
        "d": "D6",
        "key": ""
      }
    ]
  },
  {
    "id": "B40",
    "name": "一般大学院",
    "info": "",
    "dormitory": "",
    "scholarship": "",
    "B_fee": "",
    "B_fee_name": "",
    "connections": [
      {
        "a": "A29",
        "c": "C143",
        "d": "D12",
        "key": ""
      },
      {
        "a": "A29",
        "c": "C144",
        "d": "D12",
        "key": ""
      },
      {
        "a": "A29",
        "c": "C145",
        "d": "D12",
        "key": ""
      },
      {
        "a": "A29",
        "c": "C146",
        "d": "D12",
        "key": ""
      },
      {
        "a": "A29",
        "c": "C147",
        "d": "D12",
        "key": ""
      },
      {
        "a": "A29",
        "c": "C148",
        "d": "D1",
        "key": ""
      },
      {
        "a": "A29",
        "c": "C149",
        "d": "D12",
        "key": ""
      },
      {
        "a": "A29",
        "c": "C150",
        "d": "D12",
        "key": ""
      },
      {
        "a": "A29",
        "c": "C151",
        "d": "D12",
        "key": ""
      }
    ]
  },
  {
    "id": "B41",
    "name": "潮流文化大学院",
    "info": "",
    "dormitory": "",
    "scholarship": "",
    "B_fee": "",
    "B_fee_name": "",
    "connections": []
  },
  {
    "id": "B42",
    "name": "一般大学院",
    "info": "",
    "dormitory": "5500/学期",
    "scholarship": "",
    "B_fee": "10000元",
    "B_fee_name": "韩国语特别课程",
    "connections": [
      {
        "a": "A31",
        "c": "C153",
        "d": "D4",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C154",
        "d": "D7",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C155",
        "d": "D13",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C156",
        "d": "D13",
        "key": ""
      }
    ]
  },
  {
    "id": "B43",
    "name": "一般大学院",
    "info": "",
    "dormitory": "5695/6个月",
    "scholarship": "",
    "B_fee": "780元",
    "B_fee_name": "安置费",
    "connections": [
      {
        "a": "A32",
        "c": "C157",
        "d": "D8",
        "key": ""
      },
      {
        "a": "A32",
        "c": "C158",
        "d": "D99",
        "key": ""
      },
      {
        "a": "A32",
        "c": "C159",
        "d": "D6",
        "key": ""
      },
      {
        "a": "A32",
        "c": "C160",
        "d": "D99",
        "key": ""
      },
      {
        "a": "A32",
        "c": "C161",
        "d": "D11",
        "key": ""
      },
      {
        "a": "A32",
        "c": "C162",
        "d": "D1",
        "key": ""
      },
      {
        "a": "A32",
        "c": "C163",
        "d": "D20",
        "key": ""
      },
      {
        "a": "A32",
        "c": "C164",
        "d": "D4",
        "key": ""
      }
    ]
  },
  {
    "id": "B44",
    "name": "一般大学院",
    "info": "",
    "dormitory": "3600/3个月",
    "scholarship": "",
    "B_fee": "",
    "B_fee_name": "",
    "connections": [
      {
        "a": "A33",
        "c": "C165",
        "d": "D2",
        "key": ""
      }
    ]
  },
  {
    "id": "B45",
    "name": "一般大学院",
    "info": "",
    "dormitory": "5000/学期",
    "scholarship": "",
    "B_fee": "",
    "B_fee_name": "",
    "connections": [
      {
        "a": "A34",
        "c": "C166",
        "d": "D4",
        "key": ""
      },
      {
        "a": "A34",
        "c": "C167",
        "d": "D4",
        "key": ""
      },
      {
        "a": "A34",
        "c": "C168",
        "d": "D4",
        "key": ""
      },
      {
        "a": "A34",
        "c": "C169",
        "d": "D1",
        "key": ""
      },
      {
        "a": "A34",
        "c": "C170",
        "d": "D4",
        "key": ""
      },
      {
        "a": "A34",
        "c": "C171",
        "d": "D17",
        "key": ""
      },
      {
        "a": "A34",
        "c": "C172",
        "d": "D1",
        "key": ""
      },
      {
        "a": "A34",
        "c": "C173",
        "d": "D11",
        "key": ""
      },
      {
        "a": "A34",
        "c": "C174",
        "d": "D11",
        "key": ""
      },
      {
        "a": "A34",
        "c": "C175",
        "d": "D19",
        "key": ""
      }
    ]
  },
  {
    "id": "B46",
    "name": "一般大学院",
    "info": "",
    "dormitory": "3500/学期",
    "scholarship": "",
    "B_fee": "6000元",
    "B_fee_name": "校内语言课程",
    "connections": [
      {
        "a": "A35",
        "c": "C176",
        "d": "D1",
        "key": ""
      },
      {
        "a": "A35",
        "c": "C177",
        "d": "D1",
        "key": ""
      },
      {
        "a": "A35",
        "c": "C178",
        "d": "D1",
        "key": ""
      },
      {
        "a": "A35",
        "c": "C179",
        "d": "D1",
        "key": ""
      },
      {
        "a": "A35",
        "c": "C180",
        "d": "D4",
        "key": ""
      },
      {
        "a": "A35",
        "c": "C181",
        "d": "D4",
        "key": ""
      },
      {
        "a": "A35",
        "c": "C182",
        "d": "D1",
        "key": ""
      },
      {
        "a": "A35",
        "c": "C183",
        "d": "D7",
        "key": ""
      },
      {
        "a": "A35",
        "c": "C184",
        "d": "D7",
        "key": ""
      },
      {
        "a": "A35",
        "c": "C185",
        "d": "D99",
        "key": ""
      },
      {
        "a": "A35",
        "c": "C186",
        "d": "D11",
        "key": ""
      },
      {
        "a": "A35",
        "c": "C187",
        "d": "D11",
        "key": ""
      }
    ]
  },
  {
    "id": "B47",
    "name": "一般大学院",
    "info": "",
    "dormitory": "4000/学期",
    "scholarship": "",
    "B_fee": "6400元+6400元",
    "B_fee_name": "语言课程+翻译费用",
    "connections": [
      {
        "a": "A36",
        "c": "C188",
        "d": "D16",
        "key": ""
      },
      {
        "a": "A36",
        "c": "C189",
        "d": "D16",
        "key": ""
      },
      {
        "a": "A36",
        "c": "C190",
        "d": "D1",
        "key": ""
      },
      {
        "a": "A36",
        "c": "C191",
        "d": "D7",
        "key": ""
      }
    ]
  }
];
export const cItems = [
  {
    "id": "C1",
    "name": "文化contents",
    "University": "A1",
    "Expertise": "B1",
    "A_Fee": "68147元",
    "Sche": "1年",
    "no_prerequisites": false,
    "Interview": false,
    "Camp": "庆山校区",
    "D_ID": "D5"
  },
  {
    "id": "C2",
    "name": "法学",
    "University": "A1",
    "Expertise": "B1",
    "A_Fee": "68147元",
    "Sche": "1年",
    "no_prerequisites": false,
    "Interview": false,
    "Camp": "庆山校区",
    "D_ID": "D2"
  },
  {
    "id": "C3",
    "name": "会计学",
    "University": "A1",
    "Expertise": "B1",
    "A_Fee": "68147元",
    "Sche": "1年",
    "no_prerequisites": false,
    "Interview": false,
    "Camp": "庆山校区",
    "D_ID": "D1"
  },
  {
    "id": "C4",
    "name": "观光经营学",
    "University": "A1",
    "Expertise": "B1",
    "A_Fee": "68147元",
    "Sche": "1年",
    "no_prerequisites": false,
    "Interview": false,
    "Camp": "庆山校区",
    "D_ID": "D1"
  },
  {
    "id": "C5",
    "name": "幼儿教育学",
    "University": "A1",
    "Expertise": "B1",
    "A_Fee": "68147元",
    "Sche": "1年",
    "no_prerequisites": false,
    "Interview": false,
    "Camp": "庆山校区",
    "D_ID": "D4"
  },
  {
    "id": "C6",
    "name": "特殊教育学",
    "University": "A1",
    "Expertise": "B1",
    "A_Fee": "68147元",
    "Sche": "1年",
    "no_prerequisites": false,
    "Interview": false,
    "Camp": "庆山校区",
    "D_ID": "D4"
  },
  {
    "id": "C7",
    "name": "全球应用语言文化",
    "University": "A1",
    "Expertise": "B1",
    "A_Fee": "68147元",
    "Sche": "1年",
    "no_prerequisites": false,
    "Interview": false,
    "Camp": "庆山校区",
    "D_ID": "D3"
  },
  {
    "id": "C8",
    "name": "机械与汽车工程学",
    "University": "A1",
    "Expertise": "B1",
    "A_Fee": "94653元",
    "Sche": "1年",
    "no_prerequisites": false,
    "Interview": false,
    "Camp": "庆山校区",
    "D_ID": "D9"
  },
  {
    "id": "C9",
    "name": "生命工学",
    "University": "A1",
    "Expertise": "B1",
    "A_Fee": "94653元",
    "Sche": "1年",
    "no_prerequisites": false,
    "Interview": false,
    "Camp": "庆山校区",
    "D_ID": "D99"
  },
  {
    "id": "C10",
    "name": "计算机信息工程学",
    "University": "A1",
    "Expertise": "B1",
    "A_Fee": "94653元",
    "Sche": "1年",
    "no_prerequisites": false,
    "Interview": false,
    "Camp": "庆山校区",
    "D_ID": "D6"
  },
  {
    "id": "C11",
    "name": "新素材X源工程学",
    "University": "A1",
    "Expertise": "B1",
    "A_Fee": "94653元",
    "Sche": "1年",
    "no_prerequisites": false,
    "Interview": false,
    "Camp": "庆山校区",
    "D_ID": "D10"
  },
  {
    "id": "C12",
    "name": "体育休闲",
    "University": "A1",
    "Expertise": "B1",
    "A_Fee": "85800元",
    "Sche": "1年",
    "no_prerequisites": false,
    "Interview": false,
    "Camp": "庆山校区",
    "D_ID": "D11"
  },
  {
    "id": "C13",
    "name": "室内建筑",
    "University": "A1",
    "Expertise": "B1",
    "A_Fee": "97589元",
    "Sche": "1年",
    "no_prerequisites": false,
    "Interview": false,
    "Camp": "庆山校区",
    "D_ID": "D99"
  },
  {
    "id": "C14",
    "name": "护理学",
    "University": "A1",
    "Expertise": "B1",
    "A_Fee": "97589元",
    "Sche": "1年",
    "no_prerequisites": false,
    "Interview": false,
    "Camp": "大邱校区",
    "D_ID": "D16"
  },
  {
    "id": "C15",
    "name": "全球商务IMBA",
    "University": "A2",
    "Expertise": "B2",
    "A_Fee": "130000元",
    "Sche": "1.5年",
    "no_prerequisites": false,
    "Interview": true,
    "Camp": "原州校区",
    "D_ID": "D1"
  },
  {
    "id": "C16",
    "name": "文化艺术经营IMBA",
    "University": "A2",
    "Expertise": "B2",
    "A_Fee": "130000元",
    "Sche": "1.5年",
    "no_prerequisites": false,
    "Interview": true,
    "Camp": "原州校区",
    "D_ID": "D1"
  },
  {
    "id": "C17",
    "name": "全球区域学",
    "University": "A2",
    "Expertise": "B3",
    "A_Fee": "155000元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "原州校区",
    "D_ID": "D15"
  },
  {
    "id": "C18",
    "name": "GSIS全球精英",
    "University": "A2",
    "Expertise": "B4",
    "A_Fee": "225000元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": false,
    "Camp": "首尔校区",
    "D_ID": "D15"
  },
  {
    "id": "C19",
    "name": "商学院IMBA",
    "University": "A3",
    "Expertise": "B5",
    "A_Fee": "113105元",
    "Sche": "1.5年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "首尔校区",
    "D_ID": "D1"
  },
  {
    "id": "C20",
    "name": "媒体传播学MET",
    "University": "A4",
    "Expertise": "B5",
    "A_Fee": "96816元",
    "Sche": "1.5年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "首尔校区",
    "D_ID": "D5"
  },
  {
    "id": "C21",
    "name": "GMBA",
    "University": "A4",
    "Expertise": "B6",
    "A_Fee": "138469元",
    "Sche": "1.5年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "首尔校区",
    "D_ID": "D1"
  },
  {
    "id": "C22",
    "name": "创业学",
    "University": "A5",
    "Expertise": "B7",
    "A_Fee": "115000元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "世宗校区",
    "D_ID": "D99"
  },
  {
    "id": "C23",
    "name": "全球技术经营学",
    "University": "A6",
    "Expertise": "B9",
    "A_Fee": "204368元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": false,
    "Camp": "首尔校区",
    "D_ID": "D1"
  },
  {
    "id": "C24",
    "name": "东北亚学",
    "University": "A6",
    "Expertise": "B9",
    "A_Fee": "166789元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": false,
    "Camp": "首尔校区",
    "D_ID": "D15"
  },
  {
    "id": "C25",
    "name": "经营学（全球数字创新专业）",
    "University": "A6",
    "Expertise": "B10",
    "A_Fee": "226474元",
    "Sche": "1.5年",
    "no_prerequisites": true,
    "Interview": false,
    "Camp": "首尔校区",
    "D_ID": "D1"
  },
  {
    "id": "C26",
    "name": "经营学（文化内容经营专业）",
    "University": "A6",
    "Expertise": "B10",
    "A_Fee": "226474元",
    "Sche": "1.5年",
    "no_prerequisites": true,
    "Interview": false,
    "Camp": "首尔校区",
    "D_ID": "D1"
  },
  {
    "id": "C27",
    "name": "教育心理学/咨询学",
    "University": "A7",
    "Expertise": "B11",
    "A_Fee": "110000元",
    "Sche": "1年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "首尔校区",
    "D_ID": "D4"
  },
  {
    "id": "C28",
    "name": "经营学",
    "University": "A7",
    "Expertise": "B11",
    "A_Fee": "110000元",
    "Sche": "1年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "首尔校区",
    "D_ID": "D1"
  },
  {
    "id": "C29",
    "name": "经济学",
    "University": "A7",
    "Expertise": "B11",
    "A_Fee": "110000元",
    "Sche": "1年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "首尔校区",
    "D_ID": "D1"
  },
  {
    "id": "C30",
    "name": "时装设计",
    "University": "A7",
    "Expertise": "B11",
    "A_Fee": "190000元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "首尔校区",
    "D_ID": "D7"
  },
  {
    "id": "C31",
    "name": "声乐/管乐/弦乐/钢琴/实用音乐/指挥",
    "University": "A7",
    "Expertise": "B11",
    "A_Fee": "190000元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "首尔校区",
    "D_ID": "D12"
  },
  {
    "id": "C32",
    "name": "",
    "University": "",
    "Expertise": "",
    "A_Fee": "",
    "Sche": "",
    "no_prerequisites": false,
    "Interview": false,
    "Camp": "",
    "D_ID": ""
  },
  {
    "id": "C33",
    "name": "亚洲经营MBA",
    "University": "A8",
    "Expertise": "B12",
    "A_Fee": "194316元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "首尔",
    "D_ID": "D1"
  },
  {
    "id": "C34",
    "name": "全球经营MBA",
    "University": "A8",
    "Expertise": "B13",
    "A_Fee": "118947元",
    "Sche": "1.5年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "水源",
    "D_ID": "D1"
  },
  {
    "id": "C35",
    "name": "中国经营学",
    "University": "A9",
    "Expertise": "B14",
    "A_Fee": "212321元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "首尔",
    "D_ID": "D1"
  },
  {
    "id": "C36",
    "name": "新媒体制作",
    "University": "A10",
    "Expertise": "B15",
    "A_Fee": "120000元",
    "Sche": "1.5年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "首尔",
    "D_ID": "D5"
  },
  {
    "id": "C37",
    "name": "文化内容经营",
    "University": "A10",
    "Expertise": "B15",
    "A_Fee": "104000元",
    "Sche": "1.5年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "首尔",
    "D_ID": "D1"
  },
  {
    "id": "C38",
    "name": "文化艺术产业管理",
    "University": "A10",
    "Expertise": "B16",
    "A_Fee": "125000元",
    "Sche": "1.5年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "首尔",
    "D_ID": "D1"
  },
  {
    "id": "C39",
    "name": "GMBA",
    "University": "A10",
    "Expertise": "B17",
    "A_Fee": "150000元",
    "Sche": "1.5年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "首尔",
    "D_ID": "D1"
  },
  {
    "id": "C40",
    "name": "康复治疗教育学",
    "University": "A10",
    "Expertise": "B18",
    "A_Fee": "137000元",
    "Sche": "1.5年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "首尔",
    "D_ID": "D4"
  },
  {
    "id": "C41",
    "name": "舞蹈艺术教育学",
    "University": "A10",
    "Expertise": "B18",
    "A_Fee": "137000元",
    "Sche": "1.5年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "首尔",
    "D_ID": "D4"
  },
  {
    "id": "C42",
    "name": "计算机科学与技术（大数据）",
    "University": "A11",
    "Expertise": "B19",
    "A_Fee": "110000元",
    "Sche": "1.5年",
    "no_prerequisites": false,
    "Interview": true,
    "Camp": "水原",
    "D_ID": "D6"
  },
  {
    "id": "C43",
    "name": "经营学MBA",
    "University": "A12",
    "Expertise": "B21",
    "A_Fee": "114884元",
    "Sche": "1年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "首尔",
    "D_ID": "D1"
  },
  {
    "id": "C44",
    "name": "国际创业经营MBA",
    "University": "A12",
    "Expertise": "B20",
    "A_Fee": "110000元",
    "Sche": "1年（春秋正式学期，夏冬假期学期）",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "首尔",
    "D_ID": "D1"
  },
  {
    "id": "C45",
    "name": "体育与运动表现",
    "University": "A13",
    "Expertise": "B22",
    "A_Fee": "110000元",
    "Sche": "1年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "仁川",
    "D_ID": "D11"
  },
  {
    "id": "C46",
    "name": "护理学",
    "University": "A13",
    "Expertise": "B22",
    "A_Fee": "110000元",
    "Sche": "1年",
    "no_prerequisites": false,
    "Interview": true,
    "Camp": "仁川",
    "D_ID": "D16"
  },
  {
    "id": "C47",
    "name": "ai数据法律与政策",
    "University": "A13",
    "Expertise": "B22",
    "A_Fee": "110000元",
    "Sche": "1年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "仁川",
    "D_ID": "D2"
  },
  {
    "id": "C48",
    "name": "教育学",
    "University": "A13",
    "Expertise": "B22",
    "A_Fee": "110000元",
    "Sche": "1年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "仁川",
    "D_ID": "D4"
  },
  {
    "id": "C49",
    "name": "设计学",
    "University": "A13",
    "Expertise": "B22",
    "A_Fee": "130000元",
    "Sche": "1年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "仁川",
    "D_ID": "D7"
  },
  {
    "id": "C50",
    "name": "经营学",
    "University": "A13",
    "Expertise": "B22",
    "A_Fee": "110000元",
    "Sche": "1年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "仁川",
    "D_ID": "D1"
  },
  {
    "id": "C51",
    "name": "多媒体信息学",
    "University": "A13",
    "Expertise": "B22",
    "A_Fee": "110000元",
    "Sche": "1年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "仁川",
    "D_ID": "D5"
  },
  {
    "id": "C52",
    "name": "全球经营MBA",
    "University": "A13",
    "Expertise": "B23",
    "A_Fee": "75000元",
    "Sche": "1.5年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "光州",
    "D_ID": "D1"
  },
  {
    "id": "C53",
    "name": "saemaul国际开发",
    "University": "A14",
    "Expertise": "B24",
    "A_Fee": "96000元",
    "Sche": "1.5年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "庆山校区",
    "D_ID": "D15"
  },
  {
    "id": "C54",
    "name": "应用经济学",
    "University": "A15",
    "Expertise": "B24",
    "A_Fee": "96000元",
    "Sche": "1.5年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "庆山校区",
    "D_ID": "D99"
  },
  {
    "id": "C55",
    "name": "行政管理学",
    "University": "A15",
    "Expertise": "B24",
    "A_Fee": "96000元",
    "Sche": "1.5年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "庆山校区",
    "D_ID": "D99"
  },
  {
    "id": "C56",
    "name": "视觉设计学",
    "University": "A15",
    "Expertise": "B24",
    "A_Fee": "140000元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "大邱校区",
    "D_ID": "D7"
  },
  {
    "id": "C57",
    "name": "中国语言文化",
    "University": "A15",
    "Expertise": "B25",
    "A_Fee": "92000元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": false,
    "Camp": "大邱校区",
    "D_ID": "D3"
  },
  {
    "id": "C58",
    "name": "历史学",
    "University": "A15",
    "Expertise": "B25",
    "A_Fee": "92000元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": false,
    "Camp": "大邱校区",
    "D_ID": "D18"
  },
  {
    "id": "C59",
    "name": "全球商务学",
    "University": "A15",
    "Expertise": "B25",
    "A_Fee": "92000元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": false,
    "Camp": "大邱校区",
    "D_ID": "D1"
  },
  {
    "id": "C60",
    "name": "全球商务管理专业",
    "University": "A16",
    "Expertise": "B26",
    "A_Fee": "81716元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": false,
    "Camp": "春川",
    "D_ID": "D1"
  },
  {
    "id": "C61",
    "name": "艺术学专业",
    "University": "A16",
    "Expertise": "B26",
    "A_Fee": "81716元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": false,
    "Camp": "春川",
    "D_ID": "D12"
  },
  {
    "id": "C62",
    "name": "艺术经营专业",
    "University": "A16",
    "Expertise": "B26",
    "A_Fee": "81716元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": false,
    "Camp": "春川",
    "D_ID": "D1"
  },
  {
    "id": "C63",
    "name": "公演艺术",
    "University": "A17",
    "Expertise": "B27",
    "A_Fee": "159389元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "圣心校区",
    "D_ID": "D12"
  },
  {
    "id": "C64",
    "name": "舞蹈",
    "University": "A17",
    "Expertise": "B27",
    "A_Fee": "159389元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "圣心校区",
    "D_ID": "D7"
  },
  {
    "id": "C65",
    "name": "美术·设计",
    "University": "A17",
    "Expertise": "B27",
    "A_Fee": "159389元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "圣心校区",
    "D_ID": "D7"
  },
  {
    "id": "C66",
    "name": "音乐",
    "University": "A17",
    "Expertise": "B27",
    "A_Fee": "159389元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "圣心校区",
    "D_ID": "D12"
  },
  {
    "id": "C67",
    "name": "艺术经营学",
    "University": "A17",
    "Expertise": "B27",
    "A_Fee": "159389元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "圣心校区",
    "D_ID": "D1"
  },
  {
    "id": "C68",
    "name": "新媒体·文化融合",
    "University": "A17",
    "Expertise": "B27",
    "A_Fee": "159389元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "圣心校区",
    "D_ID": "D5"
  },
  {
    "id": "C69",
    "name": "文化营销融合",
    "University": "A17",
    "Expertise": "B27",
    "A_Fee": "159389元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "圣心校区",
    "D_ID": "D1"
  },
  {
    "id": "C70",
    "name": "声乐",
    "University": "A17",
    "Expertise": "B27",
    "A_Fee": "159389元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "圣心校区",
    "D_ID": "D12"
  },
  {
    "id": "C71",
    "name": "服装设计学",
    "University": "A17",
    "Expertise": "B27",
    "A_Fee": "159389元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "圣心校区",
    "D_ID": "D7"
  },
  {
    "id": "C72",
    "name": "教育行政学",
    "University": "A17",
    "Expertise": "B27",
    "A_Fee": "117221元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "圣心校区",
    "D_ID": "D4"
  },
  {
    "id": "C73",
    "name": "教育领导力",
    "University": "A17",
    "Expertise": "B27",
    "A_Fee": "117221元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "圣心校区",
    "D_ID": "D4"
  },
  {
    "id": "C74",
    "name": "国际中文教育",
    "University": "A17",
    "Expertise": "B27",
    "A_Fee": "117221元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "圣心校区",
    "D_ID": "D4"
  },
  {
    "id": "C75",
    "name": "空间设计学",
    "University": "A17",
    "Expertise": "B27",
    "A_Fee": "139537元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "圣心校区",
    "D_ID": "D7"
  },
  {
    "id": "C76",
    "name": "国际经营学",
    "University": "A18",
    "Expertise": "B28",
    "A_Fee": "93567元",
    "Sche": "1年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "首尔",
    "D_ID": "D1"
  },
  {
    "id": "C77",
    "name": "国际行政学",
    "University": "A18",
    "Expertise": "B28",
    "A_Fee": "93567元",
    "Sche": "1年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "首尔",
    "D_ID": "D99"
  },
  {
    "id": "C78",
    "name": "教育学",
    "University": "A18",
    "Expertise": "B28",
    "A_Fee": "113831元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "龙仁",
    "D_ID": "D4"
  },
  {
    "id": "C79",
    "name": "音乐艺术学",
    "University": "A18",
    "Expertise": "B28",
    "A_Fee": "149263元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "龙仁",
    "D_ID": "D12"
  },
  {
    "id": "C80",
    "name": "设计艺术学",
    "University": "A18",
    "Expertise": "B28",
    "A_Fee": "149263元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "龙仁",
    "D_ID": "D7"
  },
  {
    "id": "C81",
    "name": "电影艺术学",
    "University": "A18",
    "Expertise": "B28",
    "A_Fee": "149263元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "龙仁",
    "D_ID": "D13"
  },
  {
    "id": "C82",
    "name": "表演艺术学",
    "University": "A18",
    "Expertise": "B28",
    "A_Fee": "149263元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "龙仁",
    "D_ID": "D12"
  },
  {
    "id": "C83",
    "name": "体育科学",
    "University": "A18",
    "Expertise": "B28",
    "A_Fee": "149263元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "龙仁",
    "D_ID": "D11"
  },
  {
    "id": "C84",
    "name": "国际经营学",
    "University": "A19",
    "Expertise": "B29",
    "A_Fee": "95000元",
    "Sche": "1.5年最后一学期实习",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "首尔校区",
    "D_ID": "D1"
  },
  {
    "id": "C85",
    "name": "人事管理",
    "University": "A19",
    "Expertise": "B30",
    "A_Fee": "110000元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "首尔校区",
    "D_ID": "D1"
  },
  {
    "id": "C86",
    "name": "市场营销",
    "University": "A19",
    "Expertise": "B30",
    "A_Fee": "110000元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "首尔校区",
    "D_ID": "D1"
  },
  {
    "id": "C87",
    "name": "财务管理",
    "University": "A19",
    "Expertise": "B30",
    "A_Fee": "110000元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "首尔校区",
    "D_ID": "D1"
  },
  {
    "id": "C88",
    "name": "国际经营",
    "University": "A19",
    "Expertise": "B30",
    "A_Fee": "110000元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "首尔校区",
    "D_ID": "D1"
  },
  {
    "id": "C89",
    "name": "艺术经营",
    "University": "A19",
    "Expertise": "B30",
    "A_Fee": "110000元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "首尔校区",
    "D_ID": "D1"
  },
  {
    "id": "C90",
    "name": "文化产业经营",
    "University": "A19",
    "Expertise": "B30",
    "A_Fee": "110000元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "首尔校区",
    "D_ID": "D1"
  },
  {
    "id": "C91",
    "name": "国际经营学",
    "University": "A20",
    "Expertise": "B31",
    "A_Fee": "207426元",
    "Sche": "2年最快可一年毕业",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "龙仁",
    "D_ID": "D1"
  },
  {
    "id": "C92",
    "name": "国际经营贸易学",
    "University": "A20",
    "Expertise": "B31",
    "A_Fee": "207426元",
    "Sche": "2年最快可一年毕业",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "龙仁",
    "D_ID": "D1"
  },
  {
    "id": "C93",
    "name": "声乐专业",
    "University": "A20",
    "Expertise": "B31",
    "A_Fee": "187384元",
    "Sche": "2年最快可一年毕业",
    "no_prerequisites": false,
    "Interview": true,
    "Camp": "龙仁",
    "D_ID": "D12"
  },
  {
    "id": "C94",
    "name": "器乐专业",
    "University": "A20",
    "Expertise": "B31",
    "A_Fee": "187384元",
    "Sche": "2年最快可一年毕业",
    "no_prerequisites": false,
    "Interview": true,
    "Camp": "龙仁",
    "D_ID": "D12"
  },
  {
    "id": "C95",
    "name": "国际经营学",
    "University": "A21",
    "Expertise": "B32",
    "A_Fee": "120000元",
    "Sche": "1年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "首尔校区",
    "D_ID": "D1"
  },
  {
    "id": "C96",
    "name": "经营学专业",
    "University": "A22",
    "Expertise": "B33",
    "A_Fee": "84979元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": false,
    "Camp": "釜山",
    "D_ID": "D1"
  },
  {
    "id": "C97",
    "name": "会计学专业",
    "University": "A22",
    "Expertise": "B33",
    "A_Fee": "84979元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": false,
    "Camp": "釜山",
    "D_ID": "D1"
  },
  {
    "id": "C98",
    "name": "观光经营系",
    "University": "A22",
    "Expertise": "B33",
    "A_Fee": "84979元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": false,
    "Camp": "釜山",
    "D_ID": "D1"
  },
  {
    "id": "C99",
    "name": "国际地域学专业",
    "University": "A22",
    "Expertise": "B33",
    "A_Fee": "84979元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": false,
    "Camp": "釜山",
    "D_ID": "D15"
  },
  {
    "id": "C100",
    "name": "贸易学专业",
    "University": "A22",
    "Expertise": "B33",
    "A_Fee": "84979元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": false,
    "Camp": "釜山",
    "D_ID": "D17"
  },
  {
    "id": "C101",
    "name": "宠物学专业",
    "University": "A22",
    "Expertise": "B33",
    "A_Fee": "97674元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": false,
    "Camp": "釜山",
    "D_ID": "D99"
  },
  {
    "id": "C102",
    "name": "融合艺术系（学科间协作课程）",
    "University": "A22",
    "Expertise": "B33",
    "A_Fee": "109632元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": false,
    "Camp": "釜山",
    "D_ID": "D12"
  },
  {
    "id": "C103",
    "name": "文化艺术经营系（学科间协作课程）",
    "University": "A22",
    "Expertise": "B33",
    "A_Fee": "97674元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": false,
    "Camp": "釜山",
    "D_ID": "D1"
  },
  {
    "id": "C104",
    "name": "经营学",
    "University": "A23",
    "Expertise": "B34",
    "A_Fee": "100000元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": false,
    "Camp": "京畿道",
    "D_ID": "D1"
  },
  {
    "id": "C105",
    "name": "艺术经营",
    "University": "A23",
    "Expertise": "B34",
    "A_Fee": "100000元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": false,
    "Camp": "京畿道",
    "D_ID": "D1"
  },
  {
    "id": "C106",
    "name": "国际经营",
    "University": "A23",
    "Expertise": "B34",
    "A_Fee": "100000元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": false,
    "Camp": "京畿道",
    "D_ID": "D1"
  },
  {
    "id": "C107",
    "name": "教育学",
    "University": "A23",
    "Expertise": "B34",
    "A_Fee": "100000元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": false,
    "Camp": "京畿道",
    "D_ID": "D4"
  },
  {
    "id": "C108",
    "name": "特殊教育学",
    "University": "A23",
    "Expertise": "B34",
    "A_Fee": "100000元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": false,
    "Camp": "京畿道",
    "D_ID": "D4"
  },
  {
    "id": "C109",
    "name": "幼儿教育学",
    "University": "A23",
    "Expertise": "B34",
    "A_Fee": "100000元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": false,
    "Camp": "京畿道",
    "D_ID": "D4"
  },
  {
    "id": "C110",
    "name": "教育管理",
    "University": "A23",
    "Expertise": "B34",
    "A_Fee": "100000元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": false,
    "Camp": "京畿道",
    "D_ID": "D4"
  },
  {
    "id": "C111",
    "name": "运动康复",
    "University": "A23",
    "Expertise": "B34",
    "A_Fee": "100000元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": false,
    "Camp": "京畿道",
    "D_ID": "D99"
  },
  {
    "id": "C112",
    "name": "体育指导与体育产业",
    "University": "A23",
    "Expertise": "B34",
    "A_Fee": "100000元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": false,
    "Camp": "京畿道",
    "D_ID": "D11"
  },
  {
    "id": "C113",
    "name": "特殊体育发展康复",
    "University": "A23",
    "Expertise": "B34",
    "A_Fee": "100000元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": false,
    "Camp": "京畿道",
    "D_ID": "D11"
  },
  {
    "id": "C114",
    "name": "教育行政与教育政策",
    "University": "A24",
    "Expertise": "B35",
    "A_Fee": "353168元",
    "Sche": "1年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "首尔",
    "D_ID": "D4"
  },
  {
    "id": "C115",
    "name": "教育心理",
    "University": "A24",
    "Expertise": "B35",
    "A_Fee": "353168元",
    "Sche": "1年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "首尔",
    "D_ID": "D4"
  },
  {
    "id": "C116",
    "name": "融合教育",
    "University": "A24",
    "Expertise": "B35",
    "A_Fee": "353168元",
    "Sche": "1年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "首尔",
    "D_ID": "D4"
  },
  {
    "id": "C117",
    "name": "经营学",
    "University": "A24",
    "Expertise": "B35",
    "A_Fee": "353168元",
    "Sche": "1年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "首尔",
    "D_ID": "D1"
  },
  {
    "id": "C118",
    "name": "文化产业经营",
    "University": "A24",
    "Expertise": "B35",
    "A_Fee": "353168元",
    "Sche": "1年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "首尔",
    "D_ID": "D1"
  },
  {
    "id": "C119",
    "name": "艺术融合学科",
    "University": "A24",
    "Expertise": "B35",
    "A_Fee": "402462元",
    "Sche": "1年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "首尔",
    "D_ID": "D12"
  },
  {
    "id": "C120",
    "name": "美发设计",
    "University": "A24",
    "Expertise": "B35",
    "A_Fee": "112000元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "首尔",
    "D_ID": "D21"
  },
  {
    "id": "C121",
    "name": "美容疗法",
    "University": "A24",
    "Expertise": "B35",
    "A_Fee": "112000元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "首尔",
    "D_ID": "D21"
  },
  {
    "id": "C122",
    "name": "化妆设计",
    "University": "A24",
    "Expertise": "B35",
    "A_Fee": "112000元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "首尔",
    "D_ID": "D21"
  },
  {
    "id": "C123",
    "name": "ESG会计",
    "University": "A25",
    "Expertise": "B36",
    "A_Fee": "85032元",
    "Sche": "1年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "清州",
    "D_ID": "D99"
  },
  {
    "id": "C124",
    "name": "国际经济通商",
    "University": "A25",
    "Expertise": "B36",
    "A_Fee": "85032元",
    "Sche": "1年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "清州",
    "D_ID": "D99"
  },
  {
    "id": "C125",
    "name": "国际护理学",
    "University": "A25",
    "Expertise": "B36",
    "A_Fee": "95726元",
    "Sche": "1年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "清州",
    "D_ID": "D99"
  },
  {
    "id": "C126",
    "name": "公演艺术",
    "University": "A25",
    "Expertise": "B36",
    "A_Fee": "106800元",
    "Sche": "1年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "清州",
    "D_ID": "D12"
  },
  {
    "id": "C127",
    "name": "影像内容学",
    "University": "A26",
    "Expertise": "B37",
    "A_Fee": "110000元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": false,
    "Camp": "釜山",
    "D_ID": "D13"
  },
  {
    "id": "C128",
    "name": "电影学",
    "University": "A26",
    "Expertise": "B37",
    "A_Fee": "130000元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": false,
    "Camp": "釜山",
    "D_ID": "D13"
  },
  {
    "id": "C129",
    "name": "行政学",
    "University": "A27",
    "Expertise": "B38",
    "A_Fee": "50000元",
    "Sche": "1年",
    "no_prerequisites": true,
    "Interview": false,
    "Camp": "大邱校区",
    "D_ID": "D99"
  },
  {
    "id": "C130",
    "name": "AI大数据工程",
    "University": "A27",
    "Expertise": "B38",
    "A_Fee": "50000元",
    "Sche": "1年",
    "no_prerequisites": false,
    "Interview": false,
    "Camp": "大邱校区",
    "D_ID": "D6"
  },
  {
    "id": "C131",
    "name": "法学",
    "University": "A27",
    "Expertise": "B38",
    "A_Fee": "50000元",
    "Sche": "1年",
    "no_prerequisites": false,
    "Interview": false,
    "Camp": "大邱校区",
    "D_ID": "D2"
  },
  {
    "id": "C132",
    "name": "计算机软件学",
    "University": "A27",
    "Expertise": "B38",
    "A_Fee": "50000元",
    "Sche": "1年",
    "no_prerequisites": false,
    "Interview": false,
    "Camp": "大邱校区",
    "D_ID": "D6"
  },
  {
    "id": "C133",
    "name": "媒体广告学",
    "University": "A27",
    "Expertise": "B38",
    "A_Fee": "50000元",
    "Sche": "1年",
    "no_prerequisites": false,
    "Interview": false,
    "Camp": "大邱校区",
    "D_ID": "D5"
  },
  {
    "id": "C134",
    "name": "时尚产业",
    "University": "A27",
    "Expertise": "B38",
    "A_Fee": "50000元",
    "Sche": "1年",
    "no_prerequisites": false,
    "Interview": false,
    "Camp": "大邱校区",
    "D_ID": "D99"
  },
  {
    "id": "C135",
    "name": "体育学",
    "University": "A27",
    "Expertise": "B38",
    "A_Fee": "50000元",
    "Sche": "1年",
    "no_prerequisites": false,
    "Interview": false,
    "Camp": "大邱校区",
    "D_ID": "D11"
  },
  {
    "id": "C136",
    "name": "物理治疗",
    "University": "A27",
    "Expertise": "B38",
    "A_Fee": "50000元",
    "Sche": "1年",
    "no_prerequisites": false,
    "Interview": false,
    "Camp": "大邱校区",
    "D_ID": "D99"
  },
  {
    "id": "C137",
    "name": "新材料化学工程",
    "University": "A27",
    "Expertise": "B38",
    "A_Fee": "50000元",
    "Sche": "1年",
    "no_prerequisites": false,
    "Interview": false,
    "Camp": "大邱校区",
    "D_ID": "D10"
  },
  {
    "id": "C138",
    "name": "眼镜光学",
    "University": "A27",
    "Expertise": "B38",
    "A_Fee": "50000元",
    "Sche": "1年",
    "no_prerequisites": false,
    "Interview": false,
    "Camp": "大邱校区",
    "D_ID": "D99"
  },
  {
    "id": "C139",
    "name": "音乐学",
    "University": "A27",
    "Expertise": "B38",
    "A_Fee": "50000元",
    "Sche": "1年",
    "no_prerequisites": false,
    "Interview": false,
    "Camp": "大邱校区",
    "D_ID": "D12"
  },
  {
    "id": "C140",
    "name": "全球商务学",
    "University": "A28",
    "Expertise": "B39",
    "A_Fee": "68200元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": false,
    "Camp": "清州",
    "D_ID": "D1"
  },
  {
    "id": "C141",
    "name": "全球教育学",
    "University": "A28",
    "Expertise": "B39",
    "A_Fee": "68200元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": false,
    "Camp": "清州",
    "D_ID": "D4"
  },
  {
    "id": "C142",
    "name": "融合软件学",
    "University": "A28",
    "Expertise": "B39",
    "A_Fee": "71380元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": false,
    "Camp": "清州",
    "D_ID": "D6"
  },
  {
    "id": "C143",
    "name": "声乐",
    "University": "A29",
    "Expertise": "B40",
    "A_Fee": "160000元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "首尔",
    "D_ID": "D12"
  },
  {
    "id": "C144",
    "name": "管弦乐",
    "University": "A29",
    "Expertise": "B40",
    "A_Fee": "160000元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "首尔",
    "D_ID": "D12"
  },
  {
    "id": "C145",
    "name": "钢琴伴类",
    "University": "A29",
    "Expertise": "B40",
    "A_Fee": "160000元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "首尔",
    "D_ID": "D12"
  },
  {
    "id": "C146",
    "name": "钢琴",
    "University": "A29",
    "Expertise": "B40",
    "A_Fee": "160000元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "首尔",
    "D_ID": "D12"
  },
  {
    "id": "C147",
    "name": "合唱指挥",
    "University": "A29",
    "Expertise": "B40",
    "A_Fee": "160000元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "首尔",
    "D_ID": "D12"
  },
  {
    "id": "C148",
    "name": "文化艺术经营",
    "University": "A29",
    "Expertise": "B40",
    "A_Fee": "160000元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "首尔",
    "D_ID": "D1"
  },
  {
    "id": "C149",
    "name": "实用音乐",
    "University": "A29",
    "Expertise": "B40",
    "A_Fee": "160000元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "首尔",
    "D_ID": "D12"
  },
  {
    "id": "C150",
    "name": "民族音乐",
    "University": "A29",
    "Expertise": "B40",
    "A_Fee": "160000元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "首尔",
    "D_ID": "D12"
  },
  {
    "id": "C151",
    "name": "音乐剧",
    "University": "A29",
    "Expertise": "B40",
    "A_Fee": "160000元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "首尔",
    "D_ID": "D12"
  },
  {
    "id": "C152",
    "name": "",
    "University": "",
    "Expertise": "",
    "A_Fee": "",
    "Sche": "",
    "no_prerequisites": false,
    "Interview": false,
    "Camp": "",
    "D_ID": ""
  },
  {
    "id": "C153",
    "name": "教育学",
    "University": "A31",
    "Expertise": "B42",
    "A_Fee": "61000元",
    "Sche": "1.5年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "京畿道",
    "D_ID": "D4"
  },
  {
    "id": "C154",
    "name": "设计学",
    "University": "A31",
    "Expertise": "B42",
    "A_Fee": "78000元",
    "Sche": "1.5年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "京畿道",
    "D_ID": "D7"
  },
  {
    "id": "C155",
    "name": "公演制作学",
    "University": "A31",
    "Expertise": "B42",
    "A_Fee": "78000元",
    "Sche": "1.5年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "京畿道",
    "D_ID": "D13"
  },
  {
    "id": "C156",
    "name": "影像制作学",
    "University": "A31",
    "Expertise": "B42",
    "A_Fee": "78000元",
    "Sche": "1.5年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "京畿道",
    "D_ID": "D13"
  },
  {
    "id": "C157",
    "name": "建筑工程系",
    "University": "A32",
    "Expertise": "B43",
    "A_Fee": "88000元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "全罗南道",
    "D_ID": "D8"
  },
  {
    "id": "C158",
    "name": "运动医学系",
    "University": "A32",
    "Expertise": "B43",
    "A_Fee": "76000元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "全罗南道",
    "D_ID": "D99"
  },
  {
    "id": "C159",
    "name": "计算机学系",
    "University": "A32",
    "Expertise": "B43",
    "A_Fee": "76000元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "全罗南道",
    "D_ID": "D6"
  },
  {
    "id": "C160",
    "name": "眼视观光系",
    "University": "A32",
    "Expertise": "B43",
    "A_Fee": "76000元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "全罗南道",
    "D_ID": "D99"
  },
  {
    "id": "C161",
    "name": "体育学系",
    "University": "A32",
    "Expertise": "B43",
    "A_Fee": "76000元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "全罗南道",
    "D_ID": "D11"
  },
  {
    "id": "C162",
    "name": "经营学系",
    "University": "A32",
    "Expertise": "B43",
    "A_Fee": "71000元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "全罗南道",
    "D_ID": "D1"
  },
  {
    "id": "C163",
    "name": "心理咨询学系",
    "University": "A32",
    "Expertise": "B43",
    "A_Fee": "71000元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "全罗南道",
    "D_ID": "D20"
  },
  {
    "id": "C164",
    "name": "教育学系",
    "University": "A32",
    "Expertise": "B43",
    "A_Fee": "71000元",
    "Sche": "2年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "全罗南道",
    "D_ID": "D4"
  },
  {
    "id": "C165",
    "name": "法学",
    "University": "A33",
    "Expertise": "B44",
    "A_Fee": "8.8000元",
    "Sche": "2年",
    "no_prerequisites": false,
    "Interview": true,
    "Camp": "釜山",
    "D_ID": "D2"
  },
  {
    "id": "C166",
    "name": "教育内容开发 ",
    "University": "A34",
    "Expertise": "B45",
    "A_Fee": "89600元",
    "Sche": "1.5年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "全州",
    "D_ID": "D4"
  },
  {
    "id": "C167",
    "name": "文化教育内容开发",
    "University": "A34",
    "Expertise": "B45",
    "A_Fee": "89600元",
    "Sche": "1.5年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "全州",
    "D_ID": "D4"
  },
  {
    "id": "C168",
    "name": " 教育学 ",
    "University": "A34",
    "Expertise": "B45",
    "A_Fee": "89600元",
    "Sche": "1.5年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "全州",
    "D_ID": "D4"
  },
  {
    "id": "C169",
    "name": "艺术管理",
    "University": "A34",
    "Expertise": "B45",
    "A_Fee": "89600元",
    "Sche": "1.5年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "全州",
    "D_ID": "D1"
  },
  {
    "id": "C170",
    "name": " 儿童福祉及幼儿教育 ",
    "University": "A34",
    "Expertise": "B45",
    "A_Fee": "89600元",
    "Sche": "1.5年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "全州",
    "D_ID": "D4"
  },
  {
    "id": "C171",
    "name": "国际贸易 ",
    "University": "A34",
    "Expertise": "B45",
    "A_Fee": "89600元",
    "Sche": "1.5年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "全州",
    "D_ID": "D17"
  },
  {
    "id": "C172",
    "name": "经营 ",
    "University": "A34",
    "Expertise": "B45",
    "A_Fee": "89600元",
    "Sche": "1.5年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "全州",
    "D_ID": "D1"
  },
  {
    "id": "C173",
    "name": "体育学 ",
    "University": "A34",
    "Expertise": "B45",
    "A_Fee": "125600元",
    "Sche": "1.5年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "全州",
    "D_ID": "D11"
  },
  {
    "id": "C174",
    "name": "体育·跆拳道",
    "University": "A34",
    "Expertise": "B45",
    "A_Fee": "125600元",
    "Sche": "1.5年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "全州",
    "D_ID": "D11"
  },
  {
    "id": "C175",
    "name": " 东亚造景",
    "University": "A34",
    "Expertise": "B45",
    "A_Fee": "125600元",
    "Sche": "1.5年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "全州",
    "D_ID": "D19"
  },
  {
    "id": "C176",
    "name": "市场营销",
    "University": "A35",
    "Expertise": "B46",
    "A_Fee": "158000元",
    "Sche": "1.5年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "天安",
    "D_ID": "D1"
  },
  {
    "id": "C177",
    "name": "财务管理",
    "University": "A35",
    "Expertise": "B46",
    "A_Fee": "158000元",
    "Sche": "1.5年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "天安",
    "D_ID": "D1"
  },
  {
    "id": "C178",
    "name": "人事组织",
    "University": "A35",
    "Expertise": "B46",
    "A_Fee": "158000元",
    "Sche": "1.5年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "天安",
    "D_ID": "D1"
  },
  {
    "id": "C179",
    "name": "工商管理",
    "University": "A35",
    "Expertise": "B46",
    "A_Fee": "158000元",
    "Sche": "1.5年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "天安",
    "D_ID": "D1"
  },
  {
    "id": "C180",
    "name": "音乐教育",
    "University": "A35",
    "Expertise": "B46",
    "A_Fee": "162000元",
    "Sche": "1.5年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "天安",
    "D_ID": "D4"
  },
  {
    "id": "C181",
    "name": "教育学",
    "University": "A35",
    "Expertise": "B46",
    "A_Fee": "162000元",
    "Sche": "1.5年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "天安",
    "D_ID": "D4"
  },
  {
    "id": "C182",
    "name": "艺术管理",
    "University": "A35",
    "Expertise": "B46",
    "A_Fee": "162000元",
    "Sche": "1.5年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "天安",
    "D_ID": "D1"
  },
  {
    "id": "C183",
    "name": "视觉设计",
    "University": "A35",
    "Expertise": "B46",
    "A_Fee": "162000元",
    "Sche": "1.5年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "天安",
    "D_ID": "D7"
  },
  {
    "id": "C184",
    "name": "影像艺术设计",
    "University": "A35",
    "Expertise": "B46",
    "A_Fee": "162000元",
    "Sche": "1.5年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "天安",
    "D_ID": "D7"
  },
  {
    "id": "C185",
    "name": "整合替代医学",
    "University": "A35",
    "Expertise": "B46",
    "A_Fee": "162000元",
    "Sche": "1.5年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "天安",
    "D_ID": "D99"
  },
  {
    "id": "C186",
    "name": "体育教育",
    "University": "A35",
    "Expertise": "B46",
    "A_Fee": "162000元",
    "Sche": "1.5年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "天安",
    "D_ID": "D11"
  },
  {
    "id": "C187",
    "name": "体育学",
    "University": "A35",
    "Expertise": "B46",
    "A_Fee": "162000元",
    "Sche": "1.5年",
    "no_prerequisites": true,
    "Interview": true,
    "Camp": "天安",
    "D_ID": "D11"
  },
  {
    "id": "C188",
    "name": "护理学",
    "University": "A36",
    "Expertise": "B47",
    "A_Fee": "77400元",
    "Sche": "1年",
    "no_prerequisites": false,
    "Interview": false,
    "Camp": "",
    "D_ID": "D16"
  },
  {
    "id": "C189",
    "name": "物理治疗",
    "University": "A36",
    "Expertise": "B47",
    "A_Fee": "77400元",
    "Sche": "1年",
    "no_prerequisites": true,
    "Interview": false,
    "Camp": "",
    "D_ID": "D16"
  },
  {
    "id": "C190",
    "name": "经营学",
    "University": "A36",
    "Expertise": "B47",
    "A_Fee": "50600元",
    "Sche": "1年",
    "no_prerequisites": true,
    "Interview": false,
    "Camp": "",
    "D_ID": "D1"
  },
  {
    "id": "C191",
    "name": "多媒体设计专业",
    "University": "A36",
    "Expertise": "B47",
    "A_Fee": "67400元",
    "Sche": "1年",
    "no_prerequisites": false,
    "Interview": false,
    "Camp": "",
    "D_ID": "D7"
  },
  {
    "id": "C192",
    "name": "",
    "University": "",
    "Expertise": "",
    "A_Fee": "",
    "Sche": "",
    "no_prerequisites": false,
    "Interview": false,
    "Camp": "",
    "D_ID": ""
  },
  {
    "id": "C193",
    "name": "",
    "University": "",
    "Expertise": "",
    "A_Fee": "",
    "Sche": "",
    "no_prerequisites": false,
    "Interview": false,
    "Camp": "",
    "D_ID": ""
  },
  {
    "id": "C194",
    "name": "",
    "University": "",
    "Expertise": "",
    "A_Fee": "",
    "Sche": "",
    "no_prerequisites": false,
    "Interview": false,
    "Camp": "",
    "D_ID": ""
  }
];
export const dItems = [
  {
    "id": "D1",
    "name": "经营",
    "info": ""
  },
  {
    "id": "D2",
    "name": "法学",
    "info": ""
  },
  {
    "id": "D3",
    "name": "文学",
    "info": ""
  },
  {
    "id": "D4",
    "name": "教育学",
    "info": ""
  },
  {
    "id": "D5",
    "name": "传媒",
    "info": ""
  },
  {
    "id": "D6",
    "name": "计算机",
    "info": ""
  },
  {
    "id": "D7",
    "name": "设计",
    "info": ""
  },
  {
    "id": "D8",
    "name": "建筑工学",
    "info": ""
  },
  {
    "id": "D9",
    "name": "机械工学",
    "info": ""
  },
  {
    "id": "D10",
    "name": "材料工学",
    "info": ""
  },
  {
    "id": "D11",
    "name": "体育",
    "info": ""
  },
  {
    "id": "D12",
    "name": "艺术",
    "info": ""
  },
  {
    "id": "D13",
    "name": "电影",
    "info": ""
  },
  {
    "id": "D14",
    "name": "电子信息",
    "info": ""
  },
  {
    "id": "D15",
    "name": "国际学",
    "info": ""
  },
  {
    "id": "D16",
    "name": "护理",
    "info": ""
  },
  {
    "id": "D17",
    "name": "贸易",
    "info": ""
  },
  {
    "id": "D18",
    "name": "历史",
    "info": ""
  },
  {
    "id": "D19",
    "name": "造景",
    "info": ""
  },
  {
    "id": "D20",
    "name": "心理学",
    "info": ""
  },
  {
    "id": "D21",
    "name": "美容化妆",
    "info": ""
  },
  {
    "id": "D99",
    "name": "其他",
    "info": ""
  }
];
